<h1
  class="mb-3"
  *ngIf="!settings"
  i18n="@@settings_editProfile_managementTitle"
>
  Your profile
</h1>
<h1
  class="mb-3 setting-title"
  *ngIf="settings"
  i18n="@@settings_editProfile_title"
>
  Profile
</h1>
<p
  class="text-light mb-5"
  *ngIf="!settings"
  i18n="@@settings_editProfile_managementDescription"
>
  Filling in your profile will allow your patients to find you from the MG&Me®
  application and will give you access to their assessments
</p>
<form [formGroup]="profileCreationForm" (ngSubmit)="onSubmit()">
  <h3 i18n="@@settings_editProfile_personalInformationsTitle">
    Personal informations
  </h3>
  <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="professionalTitle"
      i18n="@@settings_editProfile_professionalTitleLabel"
    >
      Title
    </label>
    <div
      class="btn-group btn-group-toggle"
      ngbRadioGroup
      name="professionalTitle"
    >
      <label
        ngbButtonLabel
        class="radio-form btn"
        [class.active]="profile.professionalTitle === 'PR'"
      >
        <input
          ngbButton
          type="radio"
          formControlName="professionalTitle"
          [value]="professionalTitle.PR"
        />{{ professionalTitleMapping[professionalTitle.PR] }}
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="profile.professionalTitle === 'DR'"
      >
        <input
          ngbButton
          type="radio"
          formControlName="professionalTitle"
          [value]="professionalTitle.DR"
        />{{ professionalTitleMapping[professionalTitle.DR] }}
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="profile.professionalTitle === 'MRS'"
      >
        <input
          ngbButton
          type="radio"
          formControlName="professionalTitle"
          [value]="professionalTitle.MRS"
        />{{ professionalTitleMapping[professionalTitle.MRS] }}
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="profile.professionalTitle === 'MR'"
      >
        <input
          ngbButton
          type="radio"
          formControlName="professionalTitle"
          [value]="professionalTitle.MR"
        />{{ professionalTitleMapping[professionalTitle.MR] }}
      </label>
    </div>
  </div>
  <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="firstName"
      i18n="@@settings_editProfile_firstNameLabel"
    >
      First name
    </label>
    <input
      class="form-control"
      type="text"
      name="firstName"
      id="firstName"
      formControlName="firstName"
    />
    <ng-container
      *ngIf="
        profileCreationForm.get('firstName').invalid &&
        (profileCreationForm.get('firstName').dirty ||
          profileCreationForm.get('firstName').touched ||
          submittedProfileCreationForm)
      "
    >
      <small
        class="text-danger"
        *ngIf="profileCreationForm.get('firstName').errors['required']"
        i18n="@@settings_editProfile_firstNameRequiredError"
      >
        first name is required
      </small>
    </ng-container>
  </div>
  <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="lastName"
      i18n="@@settings_editProfile_lastNameLabel"
    >
      Last name
    </label>
    <input
      class="form-control"
      type="text"
      name="lastName"
      id="lastName"
      formControlName="lastName"
    />
    <ng-container
      *ngIf="
        profileCreationForm.get('lastName').invalid &&
        (profileCreationForm.get('lastName').dirty ||
          profileCreationForm.get('lastName').touched ||
          submittedProfileCreationForm)
      "
    >
      <small
        class="text-danger"
        *ngIf="profileCreationForm.get('lastName').errors['required']"
        i18n="@@settings_editProfile_lastNameRequiredError"
      >
        last name is required
      </small>
    </ng-container>
  </div>

  <h3
    class="title-section"
    i18n="@@settings_editProfile_professionalSpecialityTitle"
  >
    Professional identification
  </h3>
  <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="professionalSpeciality"
      i18n="@@settings_editProfile_professionalSpecialityLabel"
    >
      Specialisation
    </label>
    <ng-select
      [items]="professionalSpecialityMapping | keyvalue"
      bindLabel="value"
      bindValue="key"
      i18n-placeholder="
        @@settings_editProfile_professionalSpecialityLabel_placeholder"
      formControlName="professionalSpeciality"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ item.value }}
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
      >
        {{ item.value }}
      </ng-template>
    </ng-select>
    <ng-container
      *ngIf="
        profileCreationForm.get('professionalSpeciality').invalid &&
        (profileCreationForm.get('professionalSpeciality').dirty ||
          profileCreationForm.get('professionalSpeciality').touched ||
          submittedProfileCreationForm)
      "
    >
      <small
        class="text-danger"
        *ngIf="
          profileCreationForm.get('professionalSpeciality').errors['required']
        "
        i18n="@@settings_editProfile_professionalSpecialityRequiredError"
      >
        speciality is required
      </small>
    </ng-container>
  </div>
  <!-- <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="haveRpps"
      i18n="@@settings_editProfile_haveRppsLabel"
    >
      Do you have a national professional identification number? (RPPS, ADELI…)
    </label>
    <div
      class="btn-group btn-group-toggle"
      ngbRadioGroup
      name="haveRpps"
      formControlName="haveRpps"
      id="haveRpps"
    >
      <label ngbButtonLabel class="radio-form">
        <input ngbButton type="radio" [value]="true" />
        <span i18n="@@settings_editProfile_haveRppsYesLabel">Oui</span>
      </label>
      <label ngbButtonLabel class="radio-form right-radio">
        <input ngbButton type="radio" [value]="false" />
        <span i18n="@@settings_editProfile_haveRppsNoLabel">Non</span>
      </label>
    </div>
  </div> -->
  <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="haveRpps"
      i18n="@@settings_editProfile_haveRppsLabel"
    >
      Do you have a national professional identification number? (RPPS, ADELI…)*
    </label>
    <div
      class="btn-group btn-group-toggle"
      ngbRadioGroup
      name="haveRpps"
      id="true"
    >
      <label
        ngbButtonLabel
        class="radio-form btn"
        [class.active]="profileCreationForm.get('haveRpps').value === true"
      >
        <input
          ngbButton
          type="radio"
          formControlName="haveRpps"
          [value]="true"
        />
        <span i18n="@@common_yes">Oui</span>
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="profileCreationForm.get('haveRpps').value === false"
      >
        <input
          ngbButton
          type="radio"
          formControlName="haveRpps"
          [value]="false"
        />
        <span i18n="@@common_no">Non</span>
      </label>
    </div>
  </div>
  <div
    class="form-group"
    *ngIf="profileCreationForm.get('haveRpps').value === true"
  >
    <label
      class="lbl-patient fw-medium"
      for="rpps"
      i18n="@@settings_editProfile_rppsLabel"
    >
      Please enter your identification number*
    </label>
    <input
      class="form-control"
      type="text"
      name="rpps"
      id="rpps"
      placeholder="000-0000000"
      formControlName="rpps"
      maxlength="15"
    />
    <ng-container
      *ngIf="
        profileCreationForm.get('rpps').invalid &&
        (profileCreationForm.get('rpps').dirty ||
          profileCreationForm.get('rpps').touched ||
          submittedProfileCreationForm)
      "
    >
      <small
        class="text-danger"
        *ngIf="profileCreationForm.get('rpps').errors['required']"
        i18n="@@settings_editProfile_rppsRequiredError"
      >
        rpps is required
      </small>
      <small
        class="text-danger"
        *ngIf="profileCreationForm.get('rpps').errors['maxlength']"
        i18n="@@settings_editProfile_rppsLengthError"
      >
        rpps length is too long
      </small>
    </ng-container>
  </div>

  <h3 class="title-section" i18n="@@settings_editProfile_businessAddressTitle">
    Business address
  </h3>
  <div formGroupName="professionalAddress">
    <div class="form-group">
      <label
        class="lbl-patient fw-medium"
        for="professionalAddressStreet"
        i18n="@@settings_editProfile_professionalAddressStreetLabel"
      >
        Address
      </label>
      <input
        class="form-control"
        id="professionalAddressStreet"
        name="professionalAddressStreet"
        formControlName="street"
      />
      <ng-container
        *ngIf="
          profileCreationForm.get('professionalAddress').get('street')
            .invalid &&
          (profileCreationForm.get('professionalAddress').get('street').dirty ||
            profileCreationForm.get('professionalAddress').get('street')
              .touched ||
            submittedProfileCreationForm)
        "
      >
      </ng-container>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label
            class="lbl-patient fw-medium"
            for="professionalAddressZipCode"
            i18n="@@settings_editProfile_professionalAddressZipCodeLabel"
          >
            ZIP
          </label>
          <input
            class="form-control"
            id="professionalAddressZipCode"
            name="professionalAddressZipCode"
            formControlName="zipCode"
          />
          <ng-container
            *ngIf="
              profileCreationForm.get('professionalAddress').get('zipCode')
                .invalid &&
              (profileCreationForm.get('professionalAddress').get('zipCode')
                .dirty ||
                profileCreationForm.get('professionalAddress').get('zipCode')
                  .touched ||
                submittedProfileCreationForm)
            "
          >
          </ng-container>
        </div>
      </div>
      <div class="col-8">
        <div class="form-group">
          <label
            class="lbl-patient fw-medium"
            for="professionalAddressCity"
            i18n="@@settings_editProfile_townLabel"
          >
            Town
          </label>
          <input
            class="form-control"
            id="professionalAddressCity"
            name="professionalAddressCity"
            formControlName="city"
          />
          <ng-container
            *ngIf="
              profileCreationForm.get('professionalAddress').get('city')
                .invalid &&
              (profileCreationForm.get('professionalAddress').get('city')
                .dirty ||
                profileCreationForm.get('professionalAddress').get('city')
                  .touched ||
                submittedProfileCreationForm)
            "
          >
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- if onboarding -->
  <!-- <button
    *ngIf="!settings"
    type="submit"
    [disabled]="!profileCreationForm.valid"
    class="btn btn-primary mt-5 w-75"
  >
    <span i18n="@@settings_editProfile_confirmButton">Confirm</span>
    <i class="ads-icon ads-arrow-right fs-5" aria-hidden="true"></i>
  </button> -->
</form>
